export default "__VITE_ASSET__$n2BVrsj__"